/**
 * Виджет продукта в ответе ИИ — форма, которую присылает сервер
 * (`ui_show_widget`, блок `widget` отчёта; реестр — `backend/ai_agent/widgets.py`).
 * Лёгкий модуль: панель и отчёт знают форму, а сами виджеты (страницы, карта)
 * грузятся лениво (`LazyAiWidget`) — только когда ответ их прислал.
 */
/** Часть области виджета (`backend/ai_agent/widgets.py`, `scope_parts`). */
export type ScopePart =
  | { kind: 'contour'; id: number; number?: string | number | null }
  | { kind: 'farm'; id: number; name?: string | null }
  | { kind: 'cycle'; key: string; title?: string | null }
  | { kind: 'farm_cycle' }
  | { kind: 'watering'; number?: string | number | null }
  | { kind: 'work'; name: string }
  | { kind: 'campaign'; id: number }
  | { kind: 'district' };

export interface AiWidgetSpec {
  kind?: 'widget';
  widget: string;
  title: string;
  params: Record<string, string | number>;
  href?: string | null;
  /** Id экрана реестра, где виджет стоит: по нему — название экрана на языке интерфейса. */
  page?: string | null;
  page_title?: string | null;
  region?: string | null;
  /** Область, которую виджет реально показывает, — подпись сервера («агроцикл Хлопок-2026», «весь район, все культуры»). */
  scope?: string | null;
  /** Та же область по частям (`widgets.scope_parts`): подпись собирается на языке интерфейса. */
  scope_parts?: ScopePart[] | null;
  /** Отчёт по публичной ссылке: данных нет, только подпись. */
  public?: boolean;
  /** Отчёт по ссылке у вошедшего: виджет лежит вне его области чтения — только подпись. */
  outside_scope?: boolean;
}

export const isAiWidget = (value: unknown): value is AiWidgetSpec =>
  typeof value === 'object' &&
  value !== null &&
  typeof (value as AiWidgetSpec).widget === 'string' &&
  typeof (value as AiWidgetSpec).params === 'object';
